<template>
  <div class="addAndModiify">
    <el-dialog
        class="classifyDialog"
        :title="title"
        :visible.sync="isShowDialog"
        :before-close="hideAddDialog">
      <el-form :inline="true" :model="dataForm" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="120px" label="公文分类：">
              <el-input v-model="dataForm.name" placeholder="请输入标题" :readonly="isEnabled" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="120px" label="描述：">
              <el-input v-model="dataForm.descript" style="width: 100%" type="textarea"
                        :rows="3"
                        :readonly="isEnabled"
                        placeholder="请输入描述" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div  v-if="classiftType != 3" slot="footer" class="dialog-footer">
        <el-button type="info" @click="setIsShowDialog(false)">取 消</el-button>
        <el-button type="primary" @click="determineClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import {
  setAddFileTypeService,
  getTypeDetailService,
  setUpdateFileTypeService,
} from '@/services/documentServices'
export default {
  name: "addAndModiify",
  data(){
    return {
      title: '',
      dataForm: {
        name: '',
        descript: '',
      },
      isEnabled: false,
    }
  },
  props:{
    isShowDialog:{
      type: Boolean,
      default: false
    },
    classiftType: {
      type: Number,
      default: 0
    },
    systemFileTypeId: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    console.log(this.classiftType)
    if(this.classiftType == 1){
      this.title = '新增分类'
    }else if(this.classiftType == 2) {
      this.title = '修改分类'
      this.getTypeDetail();
    }else{
      this.title = '查看分类详情'
      this.isEnabled = true;
      this.getTypeDetail();
    }
  },
  methods:{
    // 获取详情
    getTypeDetail(){
      let paramsData = {
        systemFileTypeId: this.systemFileTypeId,
      }
      getTypeDetailService(paramsData).then( res => {
        if(res.code == 10000000){
          this.dataForm =  {
            name: res.data.name,
            descript: res.data.descript,
          }
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    hideAddDialog(){
      this.setIsShowDialog(false);
    },
    // 关闭窗口
    setIsShowDialog(val){
      this.$emit('setIsShowDialog', val)
    },
    // 点击确定按钮，判断是什么类型
    determineClick(){
      if(this.classiftType == 1){
        this.addClassify();
      }else if(this.classiftType == 2){
        this.updateClassify();
      }else{
        this.setIsShowDialog(false);
      }
    },
    // 新增分类
    addClassify(){
      if(!this.dataForm.name || !this.dataForm.descript) {
        this.$message.error('请填写完整信息！');
        return
      }
      let paramsData = {
        ...this.dataForm
      }
      setAddFileTypeService(paramsData).then( res => {
        if(res.code == 10000000){
          this.$message.success('新增成功！');
          this.setIsShowDialog(false);
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 修改分类
    updateClassify(){
      if(!this.dataForm.name || !this.dataForm.descript) {
        this.$message.error('请填写完整信息！');
        return
      }
      let paramsData = {
        ...this.dataForm,
        id: this.systemFileTypeId,
      }
      setUpdateFileTypeService(paramsData).then( res => {
        if(res.code == 10000000){
          this.$message.success('修改成功！');
          this.setIsShowDialog(false);
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    }
  }
}
</script>

<style scoped lang="scss">
.addAndModiify {
  background-color: white;
  /deep/.el-dialog{
    width: 35%;
    .el-textarea{
      width: 221.4px;
    }
    .el-form-item {
      width: 100%;
    }
    .el-form-item__content {
      width: calc(100% - 120px);

      .el-input {
        width: 100%;
      }
    }
  }
  .el-footer {
    text-align: right;
  }
}
</style>
